import { shuffle } from 'es-toolkit/array';
import type { Card as CardType } from '@/types';
import { CARDS_FRONTS } from './config';

export const createInitialCards = (): CardType[] =>
  shuffle(
    CARDS_FRONTS.flatMap((_, i) => {
      const currentCard: CardType = { id: 0, pairId: i, isFlipped: false, isMatched: false };

      const card1: CardType = { ...currentCard, id: i * 2 };
      const card2: CardType = { ...currentCard, id: i * 2 + 1 };

      return [card1, card2];
    }),
  );
